import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class AddPlayerModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "searchQuery", '');
    _defineProperty(this, "searching", false);
    _defineProperty(this, "searchResults", []);
    _defineProperty(this, "apiRequests", null);
    _defineProperty(this, "selectedPlayer", null);
    _defineProperty(this, "teams", []);
    _defineProperty(this, "loadingTeams", true);
    // Mode: 'api' o 'manual'
    _defineProperty(this, "mode", 'api');
    // Form state
    _defineProperty(this, "formName", '');
    _defineProperty(this, "formPhotoUrl", '');
    _defineProperty(this, "formNumber", '');
    _defineProperty(this, "formPosition", '');
    _defineProperty(this, "formBirthDate", '');
    _defineProperty(this, "formBirthPlace", '');
    _defineProperty(this, "formHeight", '');
    _defineProperty(this, "formWeight", '');
    _defineProperty(this, "formTeamId", '');
    _defineProperty(this, "formEntityType", 'player');
    _defineProperty(this, "aliases", []);
    _defineProperty(this, "newAliasText", '');
    _defineProperty(this, "saving", false);
    _defineProperty(this, "searchType", 'player');
    _defineProperty(this, "filterBy", 'league');
    _defineProperty(this, "searchTeamId", '');
    _defineProperty(this, "leagues", [{
      id: '140',
      name: 'Primera División (España)'
    }, {
      id: '141',
      name: 'Segunda División (España)'
    }, {
      id: '435',
      name: 'Primera RFEF - Grupo 1'
    }, {
      id: '436',
      name: 'Primera RFEF - Grupo 2'
    }, {
      id: '437',
      name: 'Segunda RFEF - Grupo 1'
    }, {
      id: '438',
      name: 'Segunda RFEF - Grupo 2'
    }, {
      id: '439',
      name: 'Segunda RFEF - Grupo 3'
    }, {
      id: '440',
      name: 'Segunda RFEF - Grupo 4'
    }, {
      id: '441',
      name: 'Segunda RFEF - Grupo 5'
    }, {
      id: '143',
      name: 'Copa del Rey (España)'
    }, {
      id: '2',
      name: 'Champions League'
    }, {
      id: '3',
      name: 'Europa League'
    }, {
      id: '39',
      name: 'Premier League (Inglaterra)'
    }, {
      id: '135',
      name: 'Serie A (Italia)'
    }, {
      id: '61',
      name: 'Ligue 1 (Francia)'
    }, {
      id: '78',
      name: 'Bundesliga (Alemania)'
    }]);
    _defineProperty(this, "searchLeagueId", '140');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loadTeams();
  }
  className() {
    return 'AddPlayerModal Modal--medium';
  }
  title() {
    return app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.title');
  }

  // Override the base class form submission to do nothing
  onsubmit(e) {
    e.preventDefault();
  }
  loadTeams() {
    this.loadingTeams = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/teams'
    }).then(response => {
      this.teams = app.store.pushPayload(response);
      this.loadingTeams = false;

      // Set default team if one was passed or selected in the page
      if (this.attrs.defaultTeamId) {
        this.formTeamId = String(this.attrs.defaultTeamId);
      } else if (this.teams.length > 0) {
        this.formTeamId = String(this.teams[0].id());
      }
      if (this.teams.length > 0 && !this.searchTeamId) {
        this.searchTeamId = String(this.teams[0].id());
      }
      m.redraw();
    }).catch(() => {
      this.loadingTeams = false;
      m.redraw();
    });
  }
  search(e) {
    if (e) {
      e.preventDefault();
    }
    if (this.searchQuery.trim().length < 3) {
      alert(app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.search_min_chars'));
      return;
    }
    this.searching = true;
    this.searchResults = [];
    this.apiRequests = null;
    m.redraw();
    const params = {
      search: this.searchQuery,
      type: this.searchType
    };
    if (this.filterBy === 'team') {
      if (this.searchTeamId) {
        params.team = this.searchTeamId;
      }
    } else {
      params.league = this.searchLeagueId;
    }
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/search-players',
      params
    }).then(response => {
      this.searchResults = response.results || [];
      this.apiRequests = response.requests || null;
      this.searching = false;
      m.redraw();
    }).catch(err => {
      this.searching = false;
      console.error(err);
      m.redraw();
    });
  }
  selectPlayer(apiPlayer) {
    this.selectedPlayer = apiPlayer;
    this.formName = apiPlayer.name;
    this.formPhotoUrl = apiPlayer.photoUrl || '';
    this.formNumber = apiPlayer.number !== undefined && apiPlayer.number !== null ? String(apiPlayer.number) : '';
    this.formPosition = apiPlayer.position || '';
    this.formBirthDate = apiPlayer.birthDate || '';
    this.formBirthPlace = apiPlayer.birthPlace || '';
    this.formHeight = apiPlayer.height ? String(apiPlayer.height) : '';
    this.formWeight = apiPlayer.weight ? String(apiPlayer.weight) : '';
    this.aliases = [];
    this.newAliasText = '';
    this.formEntityType = apiPlayer.entityType || this.searchType || 'player';

    // Try to match the player's team name with our loaded teams
    if (apiPlayer.teamName) {
      const matchedTeam = this.teams.find(t => t.name().toLowerCase().includes(apiPlayer.teamName.toLowerCase()) || apiPlayer.teamName.toLowerCase().includes(t.name().toLowerCase()));
      if (matchedTeam) {
        this.formTeamId = String(matchedTeam.id());
      }
    }
  }
  addAlias() {
    const alias = this.newAliasText.trim();
    if (alias && !this.aliases.includes(alias)) {
      this.aliases.push(alias);
      this.newAliasText = '';
    }
  }
  removeAlias(index) {
    this.aliases.splice(index, 1);
  }
  savePlayer(e) {
    if (e) {
      e.preventDefault();
    }
    if (!this.formName.trim()) {
      return;
    }
    this.saving = true;

    // Ensure any remaining alias input is added
    this.addAlias();
    const apiId = this.selectedPlayer ? this.selectedPlayer.id : null;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/players',
      body: {
        data: {
          type: 'nagusi_players',
          attributes: {
            apiId: apiId,
            name: this.formName.trim(),
            photoUrl: this.formPhotoUrl.trim() || null,
            isActive: true,
            aliases: this.aliases.join(','),
            number: this.formNumber ? parseInt(this.formNumber, 10) : null,
            position: this.formPosition || null,
            birthDate: this.formBirthDate || null,
            birthPlace: this.formBirthPlace.trim() || null,
            height: this.formHeight ? parseInt(this.formHeight, 10) : null,
            weight: this.formWeight ? parseInt(this.formWeight, 10) : null,
            entityType: this.formEntityType || 'player'
          },
          relationships: {
            teams: {
              data: this.formTeamId ? [{
                type: 'nagusi_teams',
                id: this.formTeamId
              }] : []
            }
          }
        }
      }
    }).then(() => {
      this.saving = false;
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.alerts.success_save'));
      this.hide();
      if (this.attrs.onSave) {
        this.attrs.onSave();
      }
    }).catch(err => {
      this.saving = false;
      console.error(err);
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.alerts.error_save'));
      m.redraw();
    });
  }
  content() {
    if (this.loadingTeams) {
      return m("div", {
        className: "Modal-body",
        style: "text-align: center; padding: 40px;"
      }, m(LoadingIndicator, null));
    }
    const isFormView = !!this.selectedPlayer || this.mode === 'manual';
    return m("div", {
      className: "Modal-body"
    }, !this.selectedPlayer && m("div", {
      className: "AddPlayer-tabs",
      style: "display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 25px; border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 15px;"
    }, m(Button, {
      className: "Button ".concat(this.mode === 'api' ? 'Button--primary' : 'Button--secondary'),
      onclick: () => {
        this.mode = 'api';
        this.selectedPlayer = null;
      },
      style: "border-radius: 8px; font-weight: bold; display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 12px; width: 100%; text-align: center;"
    }, m("i", {
      className: "fas fa-magic"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.tab_auto')), m(Button, {
      className: "Button ".concat(this.mode === 'manual' ? 'Button--primary' : 'Button--secondary'),
      onclick: () => {
        this.mode = 'manual';
        this.selectedPlayer = null;
      },
      style: "border-radius: 8px; font-weight: bold; display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 12px; width: 100%; text-align: center;"
    }, m("i", {
      className: "fas fa-user-edit"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.tab_manual'))), isFormView ? m("div", {
      className: "Form"
    }, this.selectedPlayer ? m("div", {
      style: "display: flex; align-items: center; gap: 20px; margin-bottom: 25px; padding-bottom: 20px; border-bottom: 1px solid rgba(255,255,255,0.08);"
    }, this.formPhotoUrl ? m("img", {
      src: this.formPhotoUrl,
      alt: "Player",
      style: "height: 70px; width: 70px; border-radius: 50%; object-fit: cover; border: 2px solid rgba(255, 255, 255, 0.1);"
    }) : m("div", {
      style: "height: 70px; width: 70px; border-radius: 50%; background: rgba(255,255,255,0.05); display: flex; align-items: center; justify-content: center; border: 2px solid rgba(255, 255, 255, 0.1);"
    }, m("i", {
      className: "fas fa-user",
      style: "font-size: 2.2rem; color: var(--muted-color);"
    })), m("div", null, m("h3", {
      style: "margin: 0; font-size: 1.35em; font-weight: bold; color: var(--heading-color);"
    }, this.selectedPlayer.name), m("span", {
      style: "font-size: 0.9em; color: var(--muted-color);"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.api_id'), ": ", this.selectedPlayer.id))) : m("div", {
      style: "display: flex; align-items: center; gap: 15px; margin-bottom: 25px; padding: 14px 18px; border-radius: 12px; background: rgba(59, 130, 246, 0.08); border: 1px solid rgba(59, 130, 246, 0.2);"
    }, m("i", {
      className: "fas fa-info-circle",
      style: "font-size: 1.6rem; color: #60a5fa;"
    }), m("div", {
      style: "font-size: 0.9em; color: var(--heading-color); line-height: 1.4;"
    }, m("strong", null, "Creaci\xF3n manual sin API:"), " Se le asignar\xE1 un ID interno autom\xE1tico. Podr\xE1s convocarlo y alinearlo inmediatamente, y vincularlo a la API externa m\xE1s adelante si lo deseas.")), m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.field_name')), m("input", {
      className: "FormControl",
      value: this.formName,
      oninput: e => this.formName = e.target.value,
      placeholder: "Nombre completo o futbol\xEDstico",
      required: true,
      style: "border-radius: 8px; height: 48px; min-height: 48px; padding: 12px 14px; font-size: 15px; line-height: normal; box-sizing: border-box;"
    })), m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.field_photo_url')), m("input", {
      className: "FormControl",
      value: this.formPhotoUrl,
      oninput: e => this.formPhotoUrl = e.target.value,
      placeholder: "https://...",
      style: "border-radius: 8px; height: 48px; min-height: 48px; padding: 12px 14px; font-size: 15px; line-height: normal; box-sizing: border-box;"
    })), m("div", {
      style: "display: grid; grid-template-columns: 1fr 1fr; gap: 15px;"
    }, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.fields.position')), m("select", {
      className: "FormControl",
      value: this.formPosition,
      onchange: e => this.formPosition = e.target.value,
      style: "width: 100%; border-radius: 8px; height: 48px; min-height: 48px; padding: 0 35px 0 14px; font-size: 14px; line-height: 46px; box-sizing: border-box;"
    }, m("option", {
      value: ""
    }, "-- Sin posici\xF3n --"), m("option", {
      value: "goalkeeper"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.positions.goalkeeper')), m("option", {
      value: "defender"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.positions.defender')), m("option", {
      value: "midfielder"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.positions.midfielder')), m("option", {
      value: "attacker"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.positions.attacker')))), m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.field_number')), m("input", {
      type: "number",
      className: "FormControl",
      value: this.formNumber,
      oninput: e => this.formNumber = e.target.value,
      placeholder: "p. ej. 10",
      style: "border-radius: 8px; height: 48px; min-height: 48px; padding: 12px 14px; font-size: 15px; line-height: normal; box-sizing: border-box;"
    }))), m("div", {
      style: "display: grid; grid-template-columns: 1fr 1fr; gap: 15px;"
    }, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.fields.birth_date')), m("input", {
      type: "date",
      className: "FormControl",
      value: this.formBirthDate,
      oninput: e => this.formBirthDate = e.target.value,
      style: "border-radius: 8px; height: 48px; min-height: 48px; padding: 12px 14px; font-size: 15px; line-height: normal; box-sizing: border-box;"
    })), m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.fields.birth_place')), m("input", {
      type: "text",
      className: "FormControl",
      value: this.formBirthPlace,
      oninput: e => this.formBirthPlace = e.target.value,
      placeholder: "p. ej. Bilbao",
      style: "border-radius: 8px; height: 48px; min-height: 48px; padding: 12px 14px; font-size: 15px; line-height: normal; box-sizing: border-box;"
    }))), m("div", {
      style: "display: grid; grid-template-columns: 1fr 1fr; gap: 15px;"
    }, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.field_height')), m("input", {
      type: "number",
      className: "FormControl",
      value: this.formHeight,
      oninput: e => this.formHeight = e.target.value,
      placeholder: "p. ej. 182",
      style: "border-radius: 8px; height: 48px; min-height: 48px; padding: 12px 14px; font-size: 15px; line-height: normal; box-sizing: border-box;"
    })), m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.field_weight')), m("input", {
      type: "number",
      className: "FormControl",
      value: this.formWeight,
      oninput: e => this.formWeight = e.target.value,
      placeholder: "p. ej. 75",
      style: "border-radius: 8px; height: 48px; min-height: 48px; padding: 12px 14px; font-size: 15px; line-height: normal; box-sizing: border-box;"
    }))), m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.field_team')), m("select", {
      className: "FormControl",
      value: this.formTeamId,
      onchange: e => this.formTeamId = e.target.value,
      style: "width: 100%; border-radius: 8px; height: 48px; min-height: 48px; padding: 0 35px 0 14px; font-size: 14px; line-height: 46px; box-sizing: border-box;"
    }, m("option", {
      value: ""
    }, "-- Seleccionar Equipo --"), this.teams.map(t => m("option", {
      value: t.id()
    }, t.name())))), m("div", {
      className: "Form-group"
    }, m("label", null, "Tipo de Entidad"), m("select", {
      className: "FormControl",
      value: this.formEntityType,
      onchange: e => this.formEntityType = e.target.value,
      style: "width: 100%; border-radius: 8px; height: 48px; min-height: 48px; padding: 0 35px 0 14px; font-size: 14px; line-height: 46px; box-sizing: border-box;"
    }, m("option", {
      value: "player"
    }, "Jugador"), m("option", {
      value: "coach"
    }, "Entrenador"))), m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.section_aliases')), m("p", {
      className: "helpText",
      style: "margin-bottom: 10px;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.aliases_help')), m("div", {
      style: "display: flex; gap: 10px; margin-bottom: 15px;"
    }, m("input", {
      className: "FormControl",
      placeholder: app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.new_alias_placeholder'),
      value: this.newAliasText,
      oninput: e => this.newAliasText = e.target.value,
      onkeydown: e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.addAlias();
        }
      },
      style: "flex: 1; border-radius: 8px; height: 48px; min-height: 48px; padding: 12px 14px; font-size: 15px; line-height: normal; box-sizing: border-box;"
    }), m(Button, {
      className: "Button Button--secondary",
      onclick: this.addAlias.bind(this),
      style: "height: 48px; min-height: 48px; border-radius: 8px; padding: 0 16px; font-weight: bold; display: inline-flex; align-items: center;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.btn_add_alias'))), m("div", {
      className: "Aliases-list",
      style: "display: flex; flex-wrap: wrap; gap: 8px;"
    }, this.aliases.map((alias, idx) => m("span", {
      key: idx,
      style: "display: inline-flex; align-items: center; gap: 6px; background: rgba(255,255,255,0.08); padding: 4px 10px; border-radius: 20px; font-size: 0.9em;"
    }, alias, m("button", {
      type: "button",
      onclick: () => this.removeAlias(idx),
      style: "border: none; background: none; color: var(--muted-color); cursor: pointer; padding: 0 2px; font-weight: bold;"
    }, "\xD7"))), this.aliases.length === 0 && m("span", {
      style: "color: var(--muted-color); font-style: italic; font-size: 0.95em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.empty_aliases')))), m("div", {
      className: "Modal-footer",
      style: "padding: 20px 0 0 0; margin-top: 20px; border-top: 1px solid rgba(255,255,255,0.08); display: flex; justify-content: flex-end; gap: 10px;"
    }, m(Button, {
      className: "Button",
      onclick: () => {
        if (this.selectedPlayer) {
          this.selectedPlayer = null;
        } else {
          this.hide();
        }
      }
    }, this.selectedPlayer ? 'Volver a resultados' : app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.btn_cancel')), m(Button, {
      className: "Button Button--primary",
      onclick: this.savePlayer.bind(this),
      loading: this.saving
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.btn_save')))) : m("div", null, m("div", {
      style: "margin-bottom: 20px; display: flex; flex-direction: column; gap: 10px;"
    }, m("div", {
      style: "display: flex; gap: 8px; align-items: center; width: 100%;"
    }, m("input", {
      className: "FormControl",
      placeholder: app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.search_placeholder'),
      value: this.searchQuery,
      oninput: e => this.searchQuery = e.target.value,
      onkeydown: e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.search();
        }
      },
      autoFocus: true,
      style: "flex: 1; min-width: 0; border-radius: 8px; height: 48px; min-height: 48px; padding: 12px 14px; font-size: 15px; line-height: normal; box-sizing: border-box;"
    }), m(Button, {
      className: "Button Button--primary",
      onclick: this.search.bind(this),
      loading: this.searching,
      style: "border-radius: 8px; height: 48px; min-height: 48px; padding: 0 18px; font-weight: bold; display: inline-flex; align-items: center; justify-content: center; gap: 6px; white-space: nowrap; flex-shrink: 0;"
    }, m("i", {
      className: "fas fa-search"
    }), m("span", null, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.search_btn')))), m("div", {
      style: "display: grid; grid-template-columns: 1fr 1fr; gap: 8px; width: 100%;"
    }, m("select", {
      className: "FormControl",
      value: this.searchType,
      onchange: e => this.searchType = e.target.value,
      style: "width: 100%; border-radius: 8px; height: 48px; min-height: 48px; padding: 0 35px 0 14px; font-size: 14px; line-height: 46px; box-sizing: border-box;"
    }, m("option", {
      value: "player"
    }, "Jugadores"), m("option", {
      value: "coach"
    }, "Entrenadores")), m("select", {
      className: "FormControl",
      value: this.filterBy,
      onchange: e => this.filterBy = e.target.value,
      style: "width: 100%; border-radius: 8px; height: 48px; min-height: 48px; padding: 0 35px 0 14px; font-size: 14px; line-height: 46px; box-sizing: border-box;"
    }, m("option", {
      value: "league"
    }, "Por Divisi\xF3n"), m("option", {
      value: "team"
    }, "Por Equipo"))), m("div", {
      style: "width: 100%;"
    }, this.filterBy === 'league' ? m("select", {
      className: "FormControl",
      value: this.searchLeagueId,
      onchange: e => this.searchLeagueId = e.target.value,
      style: "width: 100%; border-radius: 8px; height: 48px; min-height: 48px; padding: 0 35px 0 14px; font-size: 14px; line-height: 46px; box-sizing: border-box;"
    }, this.leagues.map(l => m("option", {
      value: l.id
    }, l.name))) : m("select", {
      className: "FormControl",
      value: this.searchTeamId,
      onchange: e => this.searchTeamId = e.target.value,
      style: "width: 100%; border-radius: 8px; height: 48px; min-height: 48px; padding: 0 35px 0 14px; font-size: 14px; line-height: 46px; box-sizing: border-box;"
    }, this.teams.map(t => m("option", {
      value: t.id()
    }, t.name()))))), this.apiRequests && m("div", {
      style: "background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 8px; padding: 10px 15px; margin-bottom: 15px; font-size: 0.9em; display: flex; align-items: center; justify-content: space-between; color: var(--muted-color);"
    }, m("div", null, m("i", {
      className: "fas fa-info-circle",
      style: "margin-right: 8px; color: var(--muted-color);"
    }), "L\xEDmite diario: ", m("strong", null, this.apiRequests.limit), ". Consultas hoy: ", m("strong", null, this.apiRequests.current), "."), m("span", {
      style: "background: rgba(255,255,255,0.08); padding: 4px 8px; border-radius: 4px; font-weight: bold; color: var(--heading-color);"
    }, "Quedan: ", this.apiRequests.remaining)), this.searching ? m("div", {
      style: "text-align: center; padding: 30px 0;"
    }, m(LoadingIndicator, null)) : m("div", {
      className: "Search-results",
      style: "max-height: 350px; overflow-y: auto; border: 1px solid rgba(255,255,255,0.06); border-radius: 8px; background: rgba(255,255,255,0.01);"
    }, this.searchResults.map(player => m("div", {
      key: player.id,
      className: "Search-result-item",
      onclick: () => this.selectPlayer(player),
      style: "display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; border-bottom: 1px solid rgba(255,255,255,0.05); cursor: pointer; transition: background 0.2s;",
      oncreate: vnode => {
        const el = vnode.dom;
        el.addEventListener('mouseenter', () => el.style.background = 'rgba(255,255,255,0.05)');
        el.addEventListener('mouseleave', () => el.style.background = 'transparent');
      }
    }, m("div", {
      style: "display: flex; align-items: center; gap: 15px;"
    }, player.photoUrl ? m("img", {
      src: player.photoUrl,
      alt: player.name,
      style: "height: 40px; width: 40px; border-radius: 50%; object-fit: cover;"
    }) : m("div", {
      style: "height: 40px; width: 40px; border-radius: 50%; background: rgba(255,255,255,0.05); display: flex; align-items: center; justify-content: center;"
    }, m("i", {
      className: "fas fa-user",
      style: "color: var(--muted-color);"
    })), m("div", {
      style: "display: flex; flex-direction: column;"
    }, m("div", {
      style: "display: flex; align-items: center; gap: 8px;"
    }, m("span", {
      style: "font-weight: bold; color: var(--heading-color);"
    }, player.name), player.entityType === 'coach' && m("span", {
      className: "Player-Role-Badge coach",
      style: "background: rgba(234, 179, 8, 0.2); color: #facc15; border: 1px solid rgba(234, 179, 8, 0.4); border-radius: 4px; padding: 1px 6px; font-size: 0.75em; font-weight: bold;"
    }, "Entrenador")), player.teamName && m("span", {
      style: "font-size: 0.85em; color: var(--muted-color);"
    }, player.teamName))), m(Button, {
      className: "Button Button--secondary Button--small"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.select_btn')))), this.searchResults.length === 0 && !this.searching && m("div", {
      style: "text-align: center; padding: 25px; color: var(--muted-color);"
    }, m("p", {
      style: "font-style: italic; margin-bottom: 15px;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.no_results')), this.searchQuery.trim().length >= 3 && m(Button, {
      className: "Button Button--secondary",
      onclick: () => {
        this.mode = 'manual';
        this.formName = this.searchQuery.trim();
      },
      style: "border-radius: 8px; font-weight: bold; display: inline-flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-plus"
    }), "Crear \"", this.searchQuery.trim(), "\" manualmente")))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/AddPlayerModal', AddPlayerModal);